import AuthorizeCC from "./authorize";

export { AuthorizeCC };

export default { AuthorizeCC };
